import { useMutation } from "@tanstack/react-query";
import urls from "../../../../../../urls";
import { useDownloadVollmacht } from "./useDownloadVollmacht";

function useDownloadVollmachtVermarkter(siteId: number) {
  const { generateAndDownloadVollmacht } = useDownloadVollmacht(siteId, {
    canGenerateUrl: urls.api.siteCanGenerateVermarkterDocuments,
    generateUrl: urls.api.generateVermarkterVollmacht,
    getUrl: urls.api.getVermarkterVollmacht
  });

  const generateAndDownloadVollmachtVermarkterMutation = useMutation({
    mutationFn: () => generateAndDownloadVollmacht()
  });

  return {
    generateAndDownloadVollmachtVermarkterMutation
  };
}

export { useDownloadVollmachtVermarkter };
